'use client';

import { Button } from '@/components/ui/button';

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { H2, Heading } from '@/components/ui/shared/heading';
import { MaterialIcon } from '@/components/ui/shared/materialIcon';
import { Pencil } from 'lucide-react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export default function DekegatesAndConsents() {
  const history = useHistory();
  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-y-2">
          <Heading variant={'userAccountTitle'}>
            {' '}
            Įgalioti asmenys ir rinkodaros sutikimai
          </Heading>
        </div>
        <Button
          type="submit"
          variant={'light'}
          onClick={() =>
            history.push('/userAccount/personal-info/manage-agreements')
          }
        >
          <MaterialIcon icon={'edit'} size={16} />
          Redaguoti
        </Button>
      </CardHeader>
    </Card>
  );
}
